/**
 * Created by Arif Topcu in 2019
 */

import AnalyticsSelectorComplication from './BetaSelectorComplication';

export default AnalyticsSelectorComplication;
